import { FieldPath, FieldValues } from 'react-hook-form';
import { FormSchema } from '@/forms/types/schema';

export const mergeSchemaAndValues = <
  TFieldValues extends FieldValues = FieldValues,
>(
  schema: FormSchema<TFieldValues>,
  values: TFieldValues,
): FormSchema<TFieldValues> => {
  const newSchema = { ...schema };
  for (const key in newSchema) {
    if (key in values) {
      const typedKey = key as FieldPath<TFieldValues>;
      newSchema[typedKey] = { ...newSchema[typedKey], value: values[key] };
    }
  }
  return newSchema;
};
